<template>
  <v-layout row>
    <v-flex xs12>
      <p class="form-subtitle">請求書の有無</p>
      <v-radio-group
        row
        required
        v-model="modelWantInvoice"
        name="want_invoice"
        :value="wantInvoice"
      >
        <v-radio v-for="(label, value) in invoiceOptions" :key="value" :value="value" :label="label"></v-radio>
      </v-radio-group>
      <v-layout row v-show="this.modelWantInvoice === '3'">
        <v-flex xs12>
          <v-text-field
            name="billing_addr"
            type="text"
            label="請求書送付先(別のご送付先をご希望の方)"
            :value="billingAddr"
            :error-messages="errorBillingAddr"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <p class="attention">※請求書の送付先が、上記に記入いただいた「ご連絡先・メールアドレス」と異なる場合、別途備考欄に記入をお願いいたします。</p>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: [
    'wantInvoice',
    'invoiceOptions',
    'billingAddr',
    'errorBillingAddr'
  ],

  data () {
    return {
      modelWantInvoice: this.wantInvoice
    }
  }
}
</script>
